<template>
<div>
  <div class="title">资讯中心<span></span></div>
  <div class="gong">
    <div style="cursor: pointer;" v-for="(item,i) of linew" :key="i">
      <div class="g-left"><img width="100%" height="100%" :src="item.nimg!=undefined?`http://upload.lusenky.com/upload/${item.nimg}`:''" alt=""></div>
      <div @click="$router.push('/hang/gonx/'+item.id)" class="g-right">
        <p>{{item.title}}</p>
        <p v-html="item.content">{{item.content}}</p>
        <p v-for="time in dataesa" :key="time">发布时间：{{time.name}}</p>
        <div class="dynamics">{{item.newType.name}}</div>
        <div class="decales">查看详情></div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props:['linew'],
   dataesa:[
      {name:"2019-6-14"},
      {name:"2019-6-20"},
      {name:"2019-5-20"},
   ],
};
</script>
<style scoped>
  .title{
    width: 148px;
    height: 45px;
    background: rgba(230,0,18,1);
    color: #fff;
    font-size: 24px;
    text-align: left;
    line-height: 45px;
    padding-left: 29px;
    font-weight: bold;
    position: relative;
  }
  .title>span{
    display: inline-block;
    width: 70px;
    height: 45px;
    background: #fff;
    right: -53px;
    border-bottom:3px solid rgba(230,0,18,1);
    position: absolute;
    -webkit-transform: skewX(45deg);
    transform: skewX(37deg);
  }
.gong{
  padding: 30px;
  border-top: 3px solid rgba(230,0,18,1);
  background:rgba(237,237,237,1);
}
.gong > div {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.g-left {
  width: 210px;
  height: 210px;
}
.g-right {
  width: 670px;
  position: relative;
}
.g-right>p:first-child{
    margin-bottom: 10px;
    font-weight: 800;
}
.g-right>p:nth-child(2){
    font-size: 14px;
    height: 95px;
    overflow: hidden;
    margin-bottom: 15px;
}
.g-right>p:nth-child(3){
    font-size: 13px;
    color:rgba(124,124,124,1);
}
.g-right .dynamics{
    margin-top: 10px;
    font-size: 14px;
    width:100px;
    height:20px;
    border:1px solid rgba(99,99,99,1);
    border-radius:5px;
    text-align: center;
    line-height: 20px;
    color: rgba(99,99,99,1);
    float: left;
}
.decales{
    width:81px;
    height:20px;
    border: 1px solid red;
    border-radius: 6px;
    color: red;
    float: left;
    font-size: 14px;
    text-align: center;
    line-height: 20px;
     margin-top: 10px;
     margin-left: 30px;
}
</style>